import { ActionContext } from 'vuex';

import { IState } from '@app/store';
import ISelection from '@models/betSlip/ISelection';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { ModalDequeEntryParams } from '@store/modules/ui/shared/modal/modalIndex';
import { SelectionSourceType } from '@superbet-group/web.types';

export function showBetBuilderConflictModal(
    { dispatch }: ActionContext<unknown, IState>,
    { selection }: { selection: ISelection },
): Promise<{ isAccepted: boolean }> {
    return new Promise((resolve) => {
        const modalDecisionCallback = ({ isAccepted }: { isAccepted: boolean }) => {
            resolve({ isAccepted });
        };

        const payload: ModalDequeEntryParams = {
            code: modalCodes.betBuilderConflict,
            isClosable: true,
            afterClose: () => resolve({ isAccepted: false }),
            data: {
                eventName: [selection.event.team1Name, selection.event.team2Name].join(' - '),
                oddName: selection.odd?.marketName,
                legs: selection.odd?.legs,
                modalDecisionCallback,
            },
        };
        dispatch(
            'ui/modal/pushModal',
            payload,
            { root: true },
        );
    });
}

export function checkIfBetBuilderIsReplaced(selection: ISelection, currentSelections: ISelection[]): { isBetBuilderReplaced: boolean; isBetBuilderIdentical: boolean; selection?: ISelection } {
    const existingBetBuilder = currentSelections.find(
        (s) => s.sourceType === SelectionSourceType.BetBuilder && s.event.id === selection.event.id && s.odd?.uuid != null,
    );
    const isBetBuilderIdentical = !!existingBetBuilder
        && existingBetBuilder.odd?.uuid === selection.odd?.uuid;

    return {
        isBetBuilderReplaced: !!existingBetBuilder,
        isBetBuilderIdentical,
        selection: existingBetBuilder,
    };
}
